import React, {useState} from 'react';
import {Box, Flex, Text} from "@chakra-ui/layout";
import {Button, FormControl, FormErrorMessage, FormLabel, Input, Textarea} from "@chakra-ui/react";
import {useSelector} from "react-redux";
import {StateType, useStudentAuthDispatch} from "../../../store/store";
import {teacherCreateCourse} from "../../../action/teacherAction";

function TeacherCreateCourse() {
  const dispatch = useStudentAuthDispatch();
  const {data: {user_id, token}} = useSelector((state: StateType) => state.rootReducer.teacherReducer);
  const teacherToken = token.includes("Bearer") ? token.slice(17, (token.length - 2)) : token.slice(10, (token.length - 2));
  const [courseName, setCourseName] = useState<string>("");
  const [courseDescription, setCourseDescription] = useState<string>("");
  const [lectureDays, setLectureDays] = useState<string>("");
  const [startTime, setStartTime] = useState<string>("");
  const [endTime, setEndTime] = useState<string>("");

  const [courseNameError, setCourseNameError] = useState<string>("");
  const [courseDescriptionError, setCourseDescriptionError] = useState<string>("");
  const [lectureDaysError, setLectureDaysError] = useState<string>("");
  const [startTimeError, setStartTimeError] = useState<string>("");
  const [endTimeError, setEndTimeError] = useState<string>("");

  async function submitForm(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.preventDefault();
    // do some checks
    if (courseName === "") {
      return setCourseNameError("This field cannot be left blank")
    }
    setCourseNameError("")
    if (courseName.length < 3 || courseName.length > 30) {
      return setCourseNameError("The length of the course name can't be less than 3 and more than 30 characters")
    }
    setCourseNameError("")
    if (courseDescription === "") {
      return setCourseDescriptionError("This field cannot be left blank")
    }
    setCourseDescriptionError("")
    if (courseDescription.length < 10 || courseDescription.length > 250) {
      return setCourseDescriptionError("The length of the course description can't be less than 10 and more than 250 characters");
    }
    setCourseDescriptionError("")
    if (lectureDays === "") {
      return setLectureDaysError("This field cannot be left blank");
    }
    setLectureDaysError("")
    if (lectureDays.length < 6 || lectureDays.length > 50) {
      return setLectureDaysError("Lecture days can't be less than 6 and more than 50 characters")
    }
    setLectureDaysError("")
    if (startTime === "") {
      return setStartTimeError("This field cannot be blank")
    }
    setStartTimeError("")
    if (endTime === "") {
      return setEndTimeError("This field cannot be blank")
    }
    setEndTimeError("")
    console.log("courses created successfully")
    const teacherId = user_id;
    const lectureHours = startTime + " to " + endTime
    const courseData = {courseName, courseDescription, lectureDays, lectureHours, teacherId}
    console.log(courseData)
    await dispatch(teacherCreateCourse(courseData, teacherToken))
  }

  return (
    <Flex m={7} p={7} flexDirection={'column'} bgColor={"white"} boxShadow="2xl" borderRadius={"30px"}>
      <Text textTransform={"capitalize"} fontWeight={"bold"} fontSize={"2xl"}>Create Course</Text>
      <Flex flexDirection={'column'} w={{base: "100%", lg: "70%"}}>
        <form>
          <FormControl isRequired mt={10} isInvalid={courseNameError !== ""}>
            <FormLabel fontSize={16} fontWeight={600}>Course Name</FormLabel>
            <Input id="courseName" type="text" autoFocus={true} placeholder="Enter the course name"
                   required
                   value={courseName} min={3} max={30}
                   onChange={(e) => setCourseName(e.target.value)}/>
            <FormErrorMessage>{courseNameError}</FormErrorMessage>
          </FormControl>
          <FormControl isRequired mt={5} isInvalid={courseDescriptionError !== ""}>
            <FormLabel fontSize={16} fontWeight={600}>Course Description</FormLabel>
            <Textarea id="courseDescription" placeholder="Enter the course description"
                      required min={10} max={250}
                      value={courseDescription} onChange={(e) => setCourseDescription(e.target.value)}/>
            <FormErrorMessage>{courseDescriptionError}</FormErrorMessage>
          </FormControl>
          <FormControl isRequired mt={5} isInvalid={lectureDaysError !== ""}>
            <FormLabel fontSize={16} fontWeight={600} htmlFor="name">Lecture Day(s)</FormLabel>
            <Input type={"text"} value={lectureDays} onChange={(e) => setLectureDays(e.target.value)}
                   placeholder={"eg: thursday or monday and wednesday"} minLength={6} maxLength={50}/>
            <FormErrorMessage>{lectureDaysError}</FormErrorMessage>
          </FormControl>
          <Text fontSize={16} fontWeight={600} mt={5}>Lecture Hours</Text>
          <Box d={"flex"} justifyContent={"space-between"} mt={2.5}>
            <FormControl isRequired isInvalid={startTimeError !== ""} w={{base: "50%", lg: "48%"}}>
              <FormLabel fontSize={16} fontWeight={600} htmlFor="name">Start</FormLabel>
              <Input type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} required/>
              <FormErrorMessage>{startTimeError}</FormErrorMessage>
            </FormControl>
            <FormControl isRequired isInvalid={endTimeError !== ""} w={{base: "50%", lg: "48%"}}>
              <FormLabel fontSize={16} fontWeight={600} htmlFor="name">End Time</FormLabel>
              <Input type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)} required/>
              <FormErrorMessage>{endTimeError}</FormErrorMessage>
            </FormControl>
          </Box>
          <br/>
          <Button type={"submit"} size="lg" textTransform={"capitalize"} fontSize={16} bgColor={"brand.darkGreen"}
                  color={"brand.white"} onClick={(e) => submitForm(e)}>Create Course</Button>
        </form>
      </Flex>
    </Flex>
  );
}

export default TeacherCreateCourse;